import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import Global from '../store/global-selectors';
import { ProviderTypes } from './constants';
import { CuiProviderSettings } from './provider-settings';
import { useApiCodeFromAccountId } from './hooks/use-api-code-from-account-id';

export const LabelProviderSettings = ({
  sellerLabelProviderId,
  onSave = noop,
  onError = noop,
  onCancel = noop,
  onUpdateSellerData = noop,
}) => {
  const providerApiCode = useApiCodeFromAccountId(sellerLabelProviderId, ProviderTypes.shipping);

  const shipFroms = useSelector(Global.selectSellerShipFroms);
  const sellerData = useMemo(() => {
    return {
      shipFroms,
    };
  }, [shipFroms]);

  if (!providerApiCode) {
    return null;
  }
  return (
    <CuiProviderSettings
      accountId={sellerLabelProviderId}
      onCancel={onCancel}
      onError={onError}
      onSave={onSave}
      onUpdateSellerData={onUpdateSellerData}
      providerApiCode={providerApiCode}
      providerType={ProviderTypes.shipping}
      sellerData={sellerData}
    />
  );
};

LabelProviderSettings.propTypes = {
  sellerLabelProviderId: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  onUpdateSellerData: PropTypes.func,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
};
